import React from 'react';

import { Provider } from './Context';
import Body from './Body'

const ChatForm = (props) => (
  <Provider {...props}>
    <div className="ChatForm">
      <Body />
    </div>
  </Provider>
);

ChatForm.propTypes = {};

export default ChatForm;
